import { render, staticRenderFns } from "./ApprovedTransaction.vue?vue&type=template&id=1b19bd2e"
import script from "./ApprovedTransaction.vue?vue&type=script&lang=js"
export * from "./ApprovedTransaction.vue?vue&type=script&lang=js"
import style0 from "./ApprovedTransaction.vue?vue&type=style&index=0&id=1b19bd2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports